var _defs, _g, _line, _line2, _polyline, _line3, _line4, _line5, _line6, _line7, _polyline2, _line8, _polyline3, _path, _rect, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconFreeAndNeutralV2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#1d1d1b;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_free-and-neutral_v2.12") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "house"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.84,48.61l.08,11.72v6.4l0,37.43H97.11l0-55.79"
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "house-2",
    "data-name": "house",
    className: "cls-1",
    x1: 60.04,
    y1: 15.28,
    x2: 103.47,
    y2: 53.41
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    id: "house-3",
    "data-name": "house",
    className: "cls-1",
    x1: 16.53,
    y1: 53.48,
    x2: 60.04,
    y2: 15.28
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "42.61 30.29 42.61 17.81 33.3 17.81 33.29 38.72"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 57.44,
    y1: 103.83,
    x2: 57.44,
    y2: 79.21
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 57.44,
    y1: 58.68,
    x2: 57.44,
    y2: 17.89
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 62.56,
    y1: 103.83,
    x2: 62.56,
    y2: 78.99
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 62.56,
    y1: 58.67,
    x2: 62.56,
    y2: 17.62
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 97.1,
    y1: 66.73,
    x2: 84.99,
    y2: 66.73
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "35.14 66.73 22.91 66.73 22.89 66.73"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 97.1,
    y1: 60.33,
    x2: 91.89,
    y2: 60.33
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "27.95 60.33 22.92 60.33 22.89 60.33"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M66.61,68.5l9.44,18.33-5.93-1.89-2,6.11c-2.68-5.4-4.44-9.31-5.6-12.06-2.27-5.31-2.31-6.24-2.56-5.18l-2.56,5.4-5.6,11.84-2-6.11L44,86.83,53.39,68.5"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 52.4,
    y: 58.73,
    width: 15.19,
    height: 9.51
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M52.44,58.48c-2.1-1.19-6.67-3.64-9.54-4.25A30.64,30.64,0,0,0,31,54.37s-1-.14-1.8,3.67c-1.07,5.06-.08,5.21-.08,5.21a30.72,30.72,0,0,1,11.73-.17C46.31,64.22,51.7,68,51.7,68"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M39.82,68.14C45.24,69.29,51.7,68,51.7,68"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.15,63.28a30.79,30.79,0,0,0,10.66,4.9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M67.74,58.48c2.1-1.19,6.67-3.64,9.54-4.25a30.64,30.64,0,0,1,11.87.14s1-.14,1.79,3.67C92,63.1,91,63.25,91,63.25a30.65,30.65,0,0,0-11.72-.17C73.87,64.22,68.48,68,68.48,68"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M80.36,68.14C74.93,69.29,68.48,68,68.48,68"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M91,63.28a30.79,30.79,0,0,1-10.66,4.9"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFreeAndNeutralV2);
export default __webpack_public_path__ + "static/media/icon_free-and-neutral_v2.a893863ef31a7c3f1247c72274a6f8fd.svg";
export { ForwardRef as ReactComponent };